import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from 'app/routes/history';
import Alert from 'app/components/general/Alert';
import _ from 'lodash';
import { IBulkMatchPaymentsSelector } from 'app/types/selector';

import * as bulkMatchPaymentsActions from 'app/ducks/bulkMatchPayments/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as bulkMatchPaymentsSelectors from 'app/ducks/bulkMatchPayments/selectors';

import CartBulkMatchPayment from './CartBulkMatchPayment';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    bulkMatchPayments: bulkMatchPaymentsSelectors.getBulkMatchPayments(
      state,
    ),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(bulkMatchPaymentsActions);

interface ICartProps {
  bulkMatchPayments: IBulkMatchPaymentsSelector;
  teams: any;
  match: any;
  actions: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class CartBulkMatches extends React.Component<ICartProps, {}> {
  static defaultProps: ICartProps = {
    bulkMatchPayments: {},
    match: undefined,
    actions: undefined,
  };

  componentDidMount = () => {
    if (!_.isEmpty(this.props.match.params.bulkMatchPaymentId)) {
      this.props.actions.getBulkMatchPayment(
        this.props.match.params.bulkMatchPaymentId,
      );
    }
  };

  render(): React.ReactNode {
    const { currentBulkMatchPayment } = this.props.bulkMatchPayments;
    // if (currentBulkMatchPayment.id === this.props.match.params.bulkMatchPaymentId) {
    //   return (
    //     <div className="row">
    //       <div className="col">
    //         <Alert color="error">Payment is not enabled for this match.</Alert>
    //       </div>
    //     </div>
    //   );
    // }
    if (this.props.match.params.bulkMatchPaymentId === currentBulkMatchPayment.id && _.includes(['collected'], currentBulkMatchPayment.status)) {
      history.push(
        `/payment/match/${currentBulkMatchPayment.id}/receipt`,
      );
    }
    if (!_.isEmpty(currentBulkMatchPayment)) {
      return (
        <CartBulkMatchPayment
          key={`cart-${currentBulkMatchPayment.id}`}
          {...this.props}
        />
      );
    }
    return null;
  }
}
